<template>
  <div class="view-container">
    <div class="extended-filter-block">
      <h2>
        Мое развитие
      </h2>
    </div>

    <div class="card card__with-action">

      <div class="segment-block">
        <div class="filter-segment">
          <a-segmented v-model:value="activeStatus" :options="statuses" />
        </div>

        <div class="filter-type">
          <a-segmented v-model:value="selectedFilter" :options="filterTypes" />
        </div>
        <div class="filter-button">
          <a-button size="small" class="secondary-button" @click="switchCardsType(selectedFilter === filterTypes[0] ? filterTypes[1] : filterTypes[0])">
            <template #icon>
              <SwitcherOutlined v-if="selectedFilter === filterTypes[1]" />
              <UnorderedListOutlined v-else />
            </template>
          </a-button>
        </div>
      </div>

      <div class="course-list">
        <div v-if="tableData && tableData.length && !cardsUpdating">
          <div v-if="selectedFilter === filterTypes[0]" class="course-card-list">
              <a-card v-for="(course, key) in courseActivity" :key="course.id + '_' + key" class="course-card">
                <div class="card-image-link">
                  <img :src="course.cover_image ? course.cover_image : Math.random() < 0.5 ? coverA : coverB" alt="обложка курса">
                </div>
                <div>
                  <div class="course-tag-wrapper">
                    <template v-if="course.category_name">
                      <div class="course-tag-category">
                        {{ course.category_name }}
                      </div>
                      <a-divider type="vertical" style="margin: 0"/>
                    </template>
                    <div class="tag-status">
                      <template v-if="course.status === 'finished'">
                        <span class="green-tag-text">
                          Завершено
                        </span>
                      </template>

                      <template v-else-if="course.is_expired">
                        <span class="red-tag-text">
                          До {{ course.expires_at }}
                        </span>
                      </template>

                      <template v-else-if="!course.is_expired && course.remaining_days">
                        <span :class="{'blue-tag-text': course.remaining_days > 30, 'red-tag-text': course.remaining_days < 30}">
                             До {{ course.expires_at }}
                        </span>
                      </template>

                      <template v-else-if="course.status === 'in_progress'">
                        <span class="blue-tag-text">
                             В процессе
                        </span>
                      </template>
                    </div>
                  </div>
                  <div class="course-title">
                    <a :href="course?.url ?? '/'" target="_blank">
                      {{ course.name }}
                    </a>
                  </div>
                </div>
              </a-card>
          </div>
          <div v-else>
            <TableHorizontalScrollShell ref="tableShell">
              <a-table
                ref="tableRef"
                rowKey="id"
                :columns="columns"
                :data-source="tableData"
                :scroll="tableScroll"
                :pagination="false"
                :loading="tableLoading"
                @change="handleTableChange"
                :table-layout="'fixed'"
            >
              <template #bodyCell="{ column, text, record }">
                <template v-if="column.dataIndex === 'name'">
                  <div class="course-title">
                    <a :href="record?.url ?? '/'" target="_blank">
                      {{ record.name }}
                    </a>
                  </div>
                </template>

                <template v-if="column.dataIndex === 'status'">
                  <a-tag color="green" v-if="record.status === 'finished'">
                    Завершен
                  </a-tag>
                  <a-tag class="yellow-tag" v-else-if="record.status === 'new'">
                    Не начат
                  </a-tag>
                  <a-tag v-else-if="record.is_expired" class="red-tag">
                    В процессе
                  </a-tag>
                  <a-tag  v-else class="blue-tag">
                    В процессе
                  </a-tag>
                </template>

                <template v-if="column.dataIndex === 'percent_completed'">
                  <div class="course-progress">
                    <a-progress :stroke-color="'#21AC0C'" :percent="text ?? 0" :format="percent => `${percent}%`" />
                  </div>
                </template>
              </template>

              <template #emptyText>
                <div class="no-data-wrapper">
                  <img :src="NotFoundIcon" class="no-data-image" alt="Нет результатов"/>
                  <div class="no-data-text">
                    'Нет данных для отображения'
                  </div>
                </div>
              </template>
            </a-table>
            </TableHorizontalScrollShell>
          </div>
        </div>
        <div v-else-if="!tableData || cardsUpdating" class="loading-block">
          <a-spin/>
        </div>
      </div>

      <div class="pagination-block">
        <a-pagination v-model:current="currentPage"
                      :page-size="entitiesPerPage"
                      :buildOptionText="(count) => `${count.value} / стр`"
                      :show-total="isMobile ? undefined : (total => `Всего ${total ?? 0} элементов`)"
                      :total="courseActivityTotal ?? 0"
                      :show-less-items="isMobile"
                      @change="handlePageChange"
        />
      </div>
    </div>
  </div>
</template>

<script>
import {onBeforeMount, watch} from "@vue/runtime-core";
  import {useStore} from "vuex";
  import {computed, ref} from "@vue/reactivity";
import {MenuOutlined, PlusOutlined, ReloadOutlined, SwitcherOutlined, TableOutlined, UnorderedListOutlined} from "@ant-design/icons-vue";
  import NotFoundIcon from "@/assets/images/icons/no_data.svg";
  import coverA from '@/assets/images/default_course_image.png'
  import coverB from '@/assets/images/default_course_image_2.png'
  import TableHorizontalScrollShell from "@/components/Tables/TableScrollComponent.vue";
  import { TABLE_SCROLL_Y, useTableScroll } from "@/mixins/useTableScroll";
  import useBreakpoints from "@/mixins/useBreakpoints";

  export default {
    components: {TableOutlined, TableHorizontalScrollShell, MenuOutlined, ReloadOutlined, PlusOutlined, UnorderedListOutlined, SwitcherOutlined},
    setup() {
      const filterTypes = ['Карточки', 'Список'];
      const selectedFilter = ref(filterTypes[0]);
      const courseActivity = computed(() => store.state.users.currentCourseActivity);
      const courseActivityTotal = computed(() => store.state.users.currentCourseActivityTotal);
      const activeStatus = ref('all');

      const statuses = [
        {
          value: 'all',
          label: 'Все'
        },
        {
          value: 'new',
          label: 'Новые'
        },
        {
          value: 'in_progress',
          label: 'В процессе'
        },
        {
          value: 'finished',
          label: 'Завершены'
        },
      ];

      const store = useStore();

      const entitiesPerPage = ref(10);
      const currentPage = ref(1);
      const tableLoading = ref(true);
      const cardsUpdating = ref(false);
      const { isMobile } = useBreakpoints();

      const columns = computed(() => [
        {
          title: 'Название',
          dataIndex: 'name',
          width: 170,
          sorter: true,
        },
        {
          title: 'Статус',
          dataIndex: 'status',
          sorter: true,
          width: 100,
        },
        {
          title: 'Тип',
          dataIndex: 'category_name',
          sorter: false,
          width: 80,
        },
        {
          title: 'Завершить до',
          dataIndex: 'expires_at',
          sorter: true,
          width: 120,
        },
        {
          title: 'Прогресс',
          dataIndex: 'percent_completed',
          sorter: true,
          width: 140,
        },
        {
          title: 'Оценка',
          dataIndex: 'rate',
          sorter: false,
          width: 80,
        },
        {
          title: 'Пройдено',
          dataIndex: 'total_stages',
          sorter: false,
          width: 80,
        },
        {
          title: 'Текущий этап',
          dataIndex: 'current_stage',
          sorter: false,
          width: 180,
        },
        {
          title: 'Дата выдачи',
          dataIndex: 'activated_at',
          sorter: true,
          width: 120,
        },
        {
          title: 'Дата завершения',
          dataIndex: 'finished_at',
          sorter: true,
          width: 120,
        },
      ]);

      // пагинация
      const retrieveEntitiesPerPage = () => {
        let storageValue = localStorage.getItem('perPage');
        entitiesPerPage.value = storageValue ? Number(storageValue) : 10;
      }

      const setEntitiesPerPage = (num) => {
        localStorage.setItem('perPage', num)
      }

      const handlePageChange = (current, perPage) => {
        if (entitiesPerPage.value !== perPage) {
          entitiesPerPage.value = perPage;
          setEntitiesPerPage(entitiesPerPage.value);
        }

        currentPage.value = current;
        fetchActivities();
      }

      //сортировка
      const sortState = ref({
        field: null,
        order: null,
      });

      const handleTableChange = (pagination, filter, sorter) => {
        sortState.value = {
          field: sorter?.field ?? null,
          order: sorter?.order ?? null,
        };

        fetchActivities();
      }

      const tableData = ref([]);
      const {
        tableRef,
        tableScroll,
        updateTableYScroll,
      } = useTableScroll({
        scrollX: 1600,
        dataSource: tableData,
        scrollY: TABLE_SCROLL_Y.full,
      });

      const fetchActivities = () => {
        tableLoading.value = true;
        cardsUpdating.value = true;

        store.dispatch('users/getCourseActivity', {
          status: activeStatus.value === 'all' ? null : activeStatus.value,
          per_page: entitiesPerPage.value,
          page: currentPage.value,
          sort_field: sortState.value.field,
          sort_direction:
              sortState.value.order === 'ascend'
                  ? 'asc'
                  : sortState.value.order === 'descend'
                      ? 'desc'
                      : null,
        }).then(() => {
          tableData.value = courseActivity.value.map((el) => {
            const match = el.course_progress ? el.course_progress.match(/\((\d+)\s*\/\s*(\d+)\)\s*$/) : null;
            const stage = el.course_progress ? el.course_progress.replace(/\s*\([^)]*\)\s*$/, "").trim() : null;
            const progress = match ? `${match[1]} из ${match[2]}` : "";
            el.current_stage = stage;
            el.total_stages = progress;
            return el;
          })
        }).finally(() => {
          tableLoading.value = false;
          cardsUpdating.value = false;
        });
      }

      const getCurrentFilter = () => {
        let storageValue = localStorage.getItem('myDevelopment');
        selectedFilter.value = storageValue ?? filterTypes[0];
      }

      onBeforeMount(() => {
        getCurrentFilter();
        retrieveEntitiesPerPage();
        fetchActivities();
      });

      const tableShell = ref(null);

      const setCurrentFilter = (type) => {
        localStorage.setItem("myDevelopment", type);
      }

      const switchCardsType = (type) => {
        selectedFilter.value = type;
      }

      watch(tableLoading, async (loading) => {
        if (!loading) {
          await tableShell.value?.rebindScroll();
          await updateTableYScroll();
        }
      });

      watch(tableData, async () => {
        await tableShell.value?.rebindScroll();
        await updateTableYScroll();
      }, { deep: true });

      watch(activeStatus, async () => {
        fetchActivities();
      }, { deep: true });

      watch(selectedFilter, async () => {
        setCurrentFilter(selectedFilter.value)
      }, { deep: true });


      return {
        NotFoundIcon,
        filterTypes,
        selectedFilter,
        courseActivity,
        courseActivityTotal,
        tableLoading,
        currentPage,
        entitiesPerPage,
        handlePageChange,
        handleTableChange,
        columns,
        coverA,
        coverB,
        tableData,
        cardsUpdating,
        tableShell,
        tableRef,
        tableScroll,
        statuses,
        activeStatus,
        switchCardsType,
        isMobile
      }
    }
  }
</script>

<style scoped lang="scss">
.extended-filter-block {
  display: none;

  @media (max-width: $mobile-breakpoint) {
    margin: 24px 20px;
    display: flex;
    column-gap: 25px;
    align-items: center;
    justify-content: space-between;
  }
}

.extended-filter-block h2 {
  font-size: 20px;
  margin-bottom: 0;
  font-weight: 600;
  line-height: 120%;
}

.card {
  min-height: 85vh;
  margin-bottom: 0;
}

.segment-block {
  display: flex;
  justify-content: space-between;
  align-items: center;
  column-gap: 8px;
  margin-bottom: 20px;
}

.pagination-block {
  margin-left: auto;
  margin-top: auto;
}

.course-title {
  font-size: 14px;
  font-weight: 600;
}

.course-card-list {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  align-items: start;

  @media (max-width: $tablet-breakpoint) {
    grid-template-columns: 1fr;
  }
}

:deep(.course-card .ant-card-body) {
  display: flex;
  column-gap: 16px;

  @media (max-width: $mobile-breakpoint) {
    flex-direction: column;
  }
}

:deep(.course-card .ant-card-body::before) {
  position: absolute;
}

:deep(.course-card .ant-card-body::after) {
  position: absolute;
}


.card-image-link {
  min-width: 200px;

  @media (max-width: $mobile-breakpoint) {
    margin-bottom: 20px;
  }

  img {
    width: 200px;
    object-fit: cover;

    @media (max-width: $mobile-breakpoint) {
      width: 100%;
      max-height: 180px;
    }
  }
}

.course-tag-wrapper {
  margin-bottom: 8px;
}

:deep(.ant-table-thead >tr>th) {
  padding: 5px !important;
}

:deep(.ant-table-tbody>tr:not(.ant-table-measure-row)>td) {
  padding: 10px 5px !important;
}

:deep(.ant-table-wrapper .course-title a) {
  color: var(--main-green);
  font-weight: 400;
}

.course-list {
  margin-bottom: 20px;
}

.view-container {
  padding-top: 0;
}

.filter-button {
  display: none;

  @media (max-width: $mobile-breakpoint) {
    display: block;
  }
}

.filter-type {
  @media (max-width: $mobile-breakpoint) {
    display: none;
  }
}

.filter-button .anticon,
.course-tag-category {
  color: var(--grey-text);
}

.course-tag-category {
  text-transform: capitalize;
}

.course-tag-wrapper {
  display: flex;
  column-gap: 8px;
  font-weight: 600;
  font-size: 12px;
  line-height: 110%;
}
</style>
